export default __webpack_public_path__ + "static/media/ico_commitment_questions.dc354efa.svg";